//© 2025 Kaitlyn Troxell
import React, { useState } from "react";
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import LoadingSpinner from './LoadingSpinner';

function AddContractorModal({ setShowAddContractor, onContractorAdded }) {
  const [formData, setFormData] = useState({
    name: '',
    trade: '',
    phone: '',
    email: '',
    preferred: false,
    active: true,
    rating: 0
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.name.trim()) {
      setError('Name is required');
      return;
    }
    if (!formData.trade.trim()) {
      setError('Trade is required');
      return;
    }
    if (!formData.phone.trim()) {
      setError('Phone is required');
      return;
    }

    setSaving(true);
    setError('');

    try {
      const docRef = await addDoc(collection(db, 'contractors'), {
        name: formData.name.trim(),
        trade: formData.trade.trim(),
        phone: formData.phone.trim(),
        email: formData.email.trim(),
        preferred: formData.preferred,
        active: formData.active,
        rating: parseInt(formData.rating) || 0
      });

      // Notify parent component that a contractor was added
      if (onContractorAdded) {
        onContractorAdded({
          id: docRef.id,
          ...formData
        });
      }

      // Close modal
      setShowAddContractor(false);
    } catch (err) {
      console.error("Error adding contractor:", err);
      setError('Failed to add contractor. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {saving && <LoadingSpinner message="Adding contractor..." />}
      <div className="modal-backdrop">
        <div className="modal-container add-contractor-modal">
          <h3 className="modal-title">Add New Contractor</h3>

          {error && (
            <div className="form-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="name">
                Name <span className="required">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter contractor name"
                required />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="trade">
                Trade <span className="required">*</span>
              </label>
              <input
                type="text"
                id="trade"
                name="trade"
                value={formData.trade}
                onChange={handleChange}
                className="form-input"
                placeholder="e.g., Plumber, Electrician, Carpenter"
                required />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="phone">
                Phone <span className="required">*</span>
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
                placeholder="(555) 123-4567"
                required />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                placeholder="contractor@example.com" />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="rating">
                Rating (0-5)
              </label>
              <select
                id="rating"
                name="rating"
                value={formData.rating}
                onChange={handleChange}
                className="form-select"
              >
                <option value="0">No rating</option>
                <option value="1">1 Star</option>
                <option value="2">2 Stars</option>
                <option value="3">3 Stars</option>
                <option value="4">4 Stars</option>
                <option value="5">5 Stars</option>
              </select>
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="preferred"
                  checked={formData.preferred}
                  onChange={handleChange}
                  className="form-checkbox" />
                <span>Preferred Contractor</span>
              </label>
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="active"
                  checked={formData.active}
                  onChange={handleChange}
                  className="form-checkbox" />
                <span>Active</span>
              </label>
            </div>

            <div className="modal-actions">
              <button
                type="button"
                onClick={() => setShowAddContractor(false)}
                className="modal-cancel-btn"
                disabled={saving}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="save-btn"
                disabled={saving}
              >
                {saving ? 'Adding...' : 'Add Contractor'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </> 
  );
}

export default AddContractorModal;